import React from 'react';

class RadioGroup extends React.Component {
	handleChange = value => {
		this.props.onChange = value;
	};

	render() {
		const { children, group } = this.props;
		const childProps = {
			optionValueChange: this.handleChange,
			group,
		};

		return (
			<div>
				{React.Children.map(children, child => (
					<div>{React.cloneElement(child, childProps)}</div>
				))}
			</div>
		);
	}
}

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/Common/Radio/RadioGroup.js